import api from "./ApiService";
import { getHeaders } from "../helpers/utils";

const getRepresentatives = async () => {
  const res = await api.get("Admin/Representatives", {
    headers: getHeaders(),
  });
  return res.data;
};

const getOffices = async () => {
  const res = await api.get("Admin/Offices", {
    headers: getHeaders(),
  });
  return res.data;
};

const AdminService = {
  getRepresentatives,
  getOffices,
};

export default AdminService;
